import Agent, { compareVersion } from '../agent'
import { navigateBack } from '../router'
import knbUse from './knb-use'

export const statusbarHeight = (function () {
  if (Agent.native) {
    console.log('[screen]', window.screen)
    let statusbarHeight = 0
    if (Agent.iphone && Agent.wkwebview) {
      statusbarHeight = Agent.iphonex ? 44 : 20
    } else {
      statusbarHeight = window.screen.height - window.screen.availHeight
    }
    return statusbarHeight
  }
  return 0
})()

// dp >= 10.3, 点评启用透明导航栏策略，业务使用需进行适配，适配方案
// https://km.sankuai.com/page/32301552
function dpCompatible() {
  if (Agent.dianping && Agent.iphone) {
    // 点评这个区间参数带notitlebar的未执行safeAreaInsetsChanged
    if (
      compareVersion(Agent.version, '10.3') >= 0 &&
      compareVersion(Agent.version, '10.26') < 0 &&
      window.location.href.indexOf('notitlebar') !== -1
    ) {
      ;(document.querySelector('html') as HTMLElement).classList.add('dp-notitlebar')
    }
    if (compareVersion(Agent.version, '10.3') >= 0 && compareVersion(Agent.version, '10.26') < 0) {
      knbUse('setTitle', {
        title: '<title>&#8203;</title>',
      })
    }
  }
}

function handleNotitlebar(handleNativeBack?: Function) {
  document.title = ''
  dpCompatible()
  knbUse('setBouncesEnabled', { enabled: 0 })
  knbUse('setLLButton', {
    icon: 'text',
    text: '',
    // 不区分安卓iOS适配时，修改LLButton逻辑必须带上handle回调，避免安卓平台物理按键出错
    handle: () => {
      if (typeof handleNativeBack === 'function') {
        handleNativeBack()
      } else {
        navigateBack()
      }
    },
  })
}

// 主要需要注意点评隐藏不能调用 configShare
export default function setNavigationBarHidden(options?: {
  handleNativeBack?: Function
  statusBarStyle?: 0 | 1 // 1:状态栏字体为白色, 0:状态栏字体为黑色
  backgroundColor?: string
}) {
  if (!Agent.native) return
  const { handleNativeBack, statusBarStyle, backgroundColor } = options || {}
  // notitlebar 不一定能生效
  // if (window.location.href.indexOf('notitlebar=1') !== -1) {
  //   handleNotitlebar(handleNativeBack)
  // } else {
  knbUse('setNavigationBarHidden', {
    flag: 1,
    success: () => handleNotitlebar(handleNativeBack),
    fail: (error: any) => {
      reportError({
        name: `KNB setNavigationBarHidden 失败` + error?.errorCode,
        msg: error,
      })
    },
  })
  // }
  if (statusBarStyle === 0 || statusBarStyle === 1) {
    knbUse('setStatusBarStyle', {
      style: statusBarStyle,
      backgroundColor: backgroundColor ? backgroundColor : statusBarStyle ? '#000' : '#fff',
    })
  }
}
